<template>
  <div class="sem618-box-pc">
    <!-- 头部banner -->
    <BannerForm
      :pcBgImg="pcBgImg"
      logoSrc=""
      title="免费试用"
      showForm
      text=""
      setHeight="620"
      @setShowSuccessDialog="setShowSuccessDialog"
    >
    </BannerForm>
    <!-- banner下方信息 -->
    <div class="banner-bottom">
      <div class="content">
        <div class="item" v-for="(item, index) in bannerBottomData" :key="index">
          <div class="first-line-text">{{ item.firstLineText }}</div>
          <div class="second-line-text">{{ item.secondLineText }}</div>
        </div>
      </div>
    </div>
    <!-- 618专享权益 -->
    <div class="sem618-equity">
      <div class="title">{{ equityData.title }}</div>
      <div class="desc">{{ equityData.desc }}</div>
      <div class="info">
        <div class="item" v-for="(item, index) in equityData.equityList" :key="index">
          <div class="sub-title">{{ item.subTitle }}</div>
          <div class="msg">
            <span v-for="(msg, index) in item.msg" :key="index" :class="{ 'blod-msg': msg === item.bold }">{{ msg }}</span>
            <img :src="item.icon" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 灵活产品与能力 -->
    <ProductPower class="product-power" @showDialog="showDialog" :title="productPower.title" :powerList="productPower.powerList" />
    <!-- 无需邮寄，1分钟完成线上签署 -->
    <div class="flow-path">
      <SectionCard :isPcFlag="true" title="无需邮寄，1分钟完成线上签署" :bgImg="flowPathBg">
        <div class="path-content">
          <div class="content">
            <div class="path-left">
              <div class="one-line">
                <div class="item" v-for="item in flowPathOneLine" :key="item.key">
                  <div class="item-content">
                    <img :src="item.imgSrc" alt="" />
                    <p>{{ item.text }}</p>
                  </div>
                  <img class="one-line-arrow" v-if="item.key !== 4" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
                </div>
              </div>
              <div class="two-line">
                <img class="two-line-arrow" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
              </div>
              <div class="three-line">
                <div class="item" v-for="item in flowPathTwoLine" :key="item.key">
                  <div class="item-content">
                    <img :src="item.imgSrc" alt="" />
                    <p>{{ item.text }}</p>
                  </div>
                  <img class="three-line-arrow" v-if="item.key !== 4" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
                </div>
              </div>
            </div>
            <div class="path-right">
              <img class="qr-img" :src="qrCodeUrl" alt="" />
              <p class="qr-desc">扫码免费领取5份试用</p>
            </div>
          </div>
        </div>
      </SectionCard>
    </div>
    <SolutionList @showDialog="showDialog" :title="solutions.title" :solutionList="solutions.list" />
    <!-- 安全可靠的电子签章服务 -->
    <div class="safe-reliable">
      <SectionCard :isPcFlag="true" title="安全可靠的电子签章服务">
        <div class="content">
          <div class="card" v-for="(item, index) in safeReliableData" :key="index">
            <img :src="item.img" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">免费试用</div>
            <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- SaaS Ai -->
    <div class="saas-ai">
      <div class="saas-ai-content">
        <div class="title">SaaS平台AI能力升级 2023</div>
        <ul class="content">
          <li v-for="item in saasAiData" :key="item.key">
            <p>{{ item.desc }}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 客户案例 -->
    <OrgList class="customer-cases" :title="orgList.title" :orgTypeList="orgList.orgTypeList" :imgs="orgList.imgs" />
    <!-- 签合同·用e签宝 -->
    <NumberInfo
      @showDialog="showDialog"
      :title="numberInfo.title"
      :numberList="numberInfo.numberList"
      :qrImgUrl="numberInfo.qrImgUrl"
    ></NumberInfo>
    <!-- 底部小象留资条 -->
    <ScrollForm
      title="企业用户立即免费试用1个月"
      :show="showScrollForm"
      @msg="handleShowMsg"
      @setShowSuccessDialog="setShowSuccessDialog"
      :landingPageName="landingPageName"
    />
    <!-- 免费试用申请弹框 -->
    <UseDialog ref="dialog" />
    <!-- 提示信息 -->
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <!-- 提交完成弹框 -->
    <SuccessFrom v-if="showSuccessDialog" @closeform="showSuccessDialog = false" :qrCodeImg="qrCodeImg" />
    <!-- 右侧客服 -->
    <Contact :landingPageName="landingPageName" :saasApiContact="true" />
    <!-- 底部备案信息 -->
    <FooterBasis />
  </div>
</template>

<script>
import dataList from './dataList'
import qiyuMixin from '@/mixins/form/qiyu'
export default {
  name: 'sem618',
  mixins: [qiyuMixin],
  components: {
    BannerForm: () => import('@/components/BannerForm.vue'),
    ProductPower: () => import('@/views/extension/components/pc/ProductPower.vue'),
    SolutionList: () => import('@/views/extension/components/pc/SolutionList.vue'),
    UseDialog: () => import('@/components/UseDialog.vue'),
    OrgList: () => import('@/views/extension/components/pc/OrgList.vue'),
    NumberInfo: () => import('@/views/semtest/components/pc/NumberInfo.vue'),
    ScrollForm: () => import('@/views/extension/components/pc/ScrollForm.vue'),
    Message: () => import('@/views/extension/components/pc/Message.vue'),
    Contact: () => import('@/components/Contact.vue'),
    FooterBasis: () => import('@/components/FooterBasis.vue'),
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
    SuccessFrom: () => import('@/components/saasApiSuccessForm.vue'),
  },
  data() {
    return {
      pcBgImg: require('@/assets/images/sem618/bgImg.png'),
      bannerBottomData: dataList.bannerBottomData,
      productPower: dataList.productPower,
      flowPathOneLine: dataList.flowPathOneLine,
      flowPathTwoLine: dataList.flowPathTwoLine,
      solutions: dataList.solutions,
      safeReliableData: dataList.safeReliableData,
      saasAiData: dataList.saasAiData,
      orgList: dataList.orgList,
      numberInfo: dataList.numberInfo,
      equityData: dataList.equityData,
      flowPathBg: require('@/assets/images/sem-saas/flow-path.png'),
      qrCodeImg: require('@/assets/images/sem-local/deploy-process-qr-code.png'),
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      showScrollForm: false,
      showSuccessDialog: false,
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
      qrCodeUrl: '',
      timer: null,
    }
  },
  mounted() {
    // 卫瓴智能扫码加微组件
    this.timer = setTimeout(() => {
      this.getWeilQrCode()
    }, 1000)

    window.addEventListener('scroll', this.scrollHandle, true)
  },
  methods: {
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.showScrollForm = scrollTop >= 2280
    },
    // 留资弹框
    showDialog() {
      this.$refs.dialog.showDialog()
    },
    // 在线咨询
    OnlineConsultationClick() {
      if (this.RoutingJudgment) {
        this.handleCustomerServiceBaiduClick({ templateId: 6641070 })
      } else {
        this.handleCustomerServiceClick({ entry: 'yinzhangsecordpage' })
      }
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
    setShowSuccessDialog(v) {
      this.showSuccessDialog = v
    },
    getWeilQrCode() {
      // eslint-disable-next-line no-undef
      wlQrcodeCustomComp.getQrCodeUrl(
        {
          wl_qrcode_id: '1683768809598779392', // [修改1：将wl_qrcode_id粘贴至此]
        },
        resData => {
          const { code, data } = resData
          if (code === 200 && data) {
            if (data.qr_code) {
              // data中包含二维码图片地址
              this.qrCodeUrl = data.qr_code
              clearTimeout(this.timer)
            }
          }
        }
      )
    },
  },
}
</script>

<style lang="less">
@import './style.less';
.content-right {
  margin-left: 736px;
}
</style>
